import React, { useEffect, useState } from "react";
import { Autocomplete, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import api from "../../../../Services/api";
import { useGuia } from "../../../../Hooks/guia";
import { usePrefeitura } from "../../../../Hooks/usePrefeitura";

export const SelectAdquirentes = () => {
    const { prefeitura } = usePrefeitura();

    const { id_adquirinte, set_id_adquirinte } = useGuia();
    const [adquirentes, setAdquirentes] = useState<any[]>([]);
    const [value, setValue] = useState<any | null>(null);

    async function getAdquirentes() {
        if (prefeitura.ID) {
            const { data } = await api.get(`/adquirinte/por-entidade/${prefeitura.ID}`);
            setAdquirentes(data);
        }

    }

    useEffect(() => {
        getAdquirentes();
    }, [prefeitura]);

    return (

        <Autocomplete
            options={adquirentes}
            value={value}
            onChange={(event, newValue) => {
                setValue(newValue);

                if (newValue && newValue.COD_UNICO) {
                    set_id_adquirinte(newValue.COD_UNICO);
                } else {
                    set_id_adquirinte(0);
                }
            }}
            getOptionLabel={(option) => {
                if (!option) return "";
                return `${option.NOME || ""} (${option.COD_UNICO || ""})`;
            }}
            sx={{ width: 420 }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Adquirente"
                    size="small"
                    placeholder="Pesquisar adquirente..."
                    InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                            <>
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                                {params.InputProps.startAdornment}
                            </>
                        )
                    }}
                />
            )}
        />
    );
};